const alphabetic = "[a-zA-ZÀ-ÿ ]+"
const postalCode = "[0-9]{4}"
const phonePattern = "[0-9]{8}"

export { alphabetic, postalCode, phonePattern }
